// @ts-nocheck

import { createApp, nextTick } from 'vue'
// import { createLocalVue, mount } from '@vue/test-utils'

import App from './App.vue'
import {CmpApi} from '@iabtcf/gpp';
import {TCModel, TCString, GVL} from '@iabtcf/core';

import {CmpApi as TCFCmpApi} from '@iabtechlabtcf/cmpapi';


import {getVisitorCountryAndRegion, isGDPRCountry} from './geo'
import {getParameterByName, ampLogInfo, ampLogError, getCookie, setCookie, setCookieWithExpireTime} from './util'

import { TcfEuV2 } from '@iabtcf/gpp/encoder/section/TcfEuV2.js'; 
import { UsCaV1 } from '@iabtcf/gpp/encoder/section/UsCaV1.js'; 
import { UsCoV1 } from '@iabtcf/gpp/encoder/section/UsCoV1.js'; 
import { UsCtV1 } from '@iabtcf/gpp/encoder/section/UsCtV1.js'; 
import { UsUtV1 } from '@iabtcf/gpp/encoder/section/UsUtV1.js'; 
import { UsVaV1 } from '@iabtcf/gpp/encoder/section/UsVaV1.js';

import { updateCMPColorado, updateCMPCalifornia, updateCMPConnecticut, updateCMPUtah, updateCMPVirginia } from './components/updateCMPFuncs.js'

const CMP_BUILD = 221;
const CMP_ID = 77;
const CMP_VERSION = 4;
const CMP_CONSENTCOOKIE = "euconsent-v2";
const CMP_NONTCFCONSENTCOOKIE = "euconsent-v2-non-tcf";

const CMP_GPP_CONSENTCOOKIE = "amp-gpp-consent-string";

declare const gGDPR_publisherCountryCode: string;

const __gppMountDivID = "__cmp_mount";
let __gppAppInstance = null;


////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
//
//  Establish the CMP mount point and inject privacy links and messages
//


function __injectDOMElements( ) {
  
    let existingMountDiv = document.getElementById(__gppMountDivID);
  
    if ( existingMountDiv ) {
  
    }
    else {
      var elemDiv = document.createElement('div');
      elemDiv.id = __gppMountDivID
      document.body.appendChild(elemDiv);
      }
  
    setTimeout( () => {
  
      let onClickCommand = "window.scroll(0,0);__gppOpenUI()"; // todo: make this a function call to the GPP CMP
  
      let privacyElem = document.getElementById('ampCMP_privacyPolicy');
      if ( privacyElem)
        privacyElem.innerHTML = '<h4>Privacy Consent Management</h4><p>You can resurface the consent management platform that will allow you to edit and change your consent choices by clicking this link: <a href="javascript:void(0);" onclick="'+onClickCommand+'">Manage Your Consent</a></p>';
      
      let footerElem = document.getElementById('ampCMP_footer');
      if ( footerElem) {
        footerElem.innerHTML = '<a class="nav-link" href="javascript:void(0);" onclick="'+onClickCommand+'">Privacy Choices</a>';
      }
        
    }, 500);
  
  }
  
window.__gppOpenUI = function() {
  if ( ! __gppAppInstance ) {
    ampLogInfo( "__gppOpenUI():  __gppAppInstance not initialized" );
  } else {
  __gppAppInstance.openCMP();
  }
}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////

//  Get consent strings in and out of the GPP api and updating them in the cookie and
//  local storage locations

function __storeGPPString( encodedString : string ) : void  {
  ampLogInfo( "__storeGPPString() result = " + encodedString)
  cmpApi.setGppString( encodedString );
  setCookie(CMP_GPP_CONSENTCOOKIE, encodedString, 365 );
}

function __getGPPString(  ) : string  {
  return  cmpApi.getGppString( );
}

function __updateGPPCookie( ) : void  {

  //todo: also set this in local storage
  let gppString = __getGPPString();

  console.log( "CMP(): __updateGPPCookie() : " + gppString  ) ;

  setCookie(CMP_GPP_CONSENTCOOKIE, gppString, 365 );

}

function __getGPPCookie(  ) : string  {

  //todo: also get this in local storage

  return getCookie( CMP_GPP_CONSENTCOOKIE );

}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////

//  These functions deal with TCF (GDPR) consent strings encoded/decoded by the TCModel class,
//  feeds through to save the encoded consent string in the 'tcfeuv2' GPP section

  function __storeTCString( ) : void {
    
    

    // window.__cmpTCModel.purposeLegitimateInterests.unset( this.purpose.id );

    // this.cmpApi.setFieldValue(UsCoV1.NAME, 'SaleOptOut' )
    
    // // publisher purposes segment
    // fields.set(TcfEuV2Field.PUBLISHER_PURPOSES_SEGMENT_TYPE.toString(), new EncodableFixedInteger(3, 3));
    // fields.set(
    //   TcfEuV2Field.PUBLISHER_CONSENTS.toString(),
    //   new EncodableFixedBitfield([
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //   ])
    // );



    //@ts-ignore
    console.log( "__storeTCString() : Begins")
    console.log(window.__cmpTCModel);

    const encodedStringOld = TCString.encode(window.__cmpTCModel);

    // window.__cmpTCModel.setAllVendorsDisclosed();

    // @ts-ignore
    const encodedString = TCString.encode(window.__cmpTCModel);
  
    console.log( "storeTCString() 3 result = " + encodedString)

    setCookie(CMP_CONSENTCOOKIE, encodedString, 365 );

    setCookie(CMP_NONTCFCONSENTCOOKIE, "", 365 );

    cmpApi.setSectionString( 'tcfeuv2', encodedString);

    // https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/TcfEuV2Field.ts

    // cmpApi.setFieldValue('tcfeuv2', 'PublisherConsents', [0,0,0,0,0,0,0,0,0,0] );

    // cmpApi.setFieldValue('tcfeuv2', 'PublisherPurposesSegmentType', 3 );
    // cmpApi.setFieldValue('tcfeuv2', 'PublisherConsents', 
    //   [
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //     false,
    //   ]);


 

    cmpApi.fireEvent( "sectionChanged",  'tcfeuv2');
    cmpApi.setSignalStatus( "ready" );
    cmpApi.fireEvent( 'signalStatus', 'ready' );
    
    // tcfCmpApi.update(encodedString, false);

    __updateGPPCookie();
  }         

function __storeAcceptAllTCString() {

  console.log( "CMP(): Accept All")

  window.__cmpTCModel.setAll();

  // console.log( "Allowing all purposeLegitimateInterests")

  // for ( let v of [1,2,3,4,5,6,7,8,9,10] ) {
  //   window.__cmpTCModel.purposeLegitimateInterests.set(v);
  // }

  // ampLogInfo( "Allowing all vendorLegitimateInterests")

  // for (var i = 1; i <= 1100; i++) {
  //   window.__cmpTCModel.purposeLegitimateInterests.set(i);
  // }

if ( typeof gGDPR_NonTCFVendors !="undefined" ) {
    gGDPR_NonTCFVendors.forEach(( element:object, index : number, a:Array<object> ) => {
    gGDPR_NonTCFVendors[index].consent = gGDPR_NonTCFVendors[index].modelConsent = true;
    });
  }

  __storeTCString();
}


function __storeRejectAllTCString() {

  ampLogInfo( "Reject All")
    
    // todo: gpp model

    window.__cmpTCModel.unsetAll();  // this is the GDPR flavor

  if ( typeof gGDPR_NonTCFVendors !="undefined" ) {
      gGDPR_NonTCFVendors.forEach(( element:object, index : number, a:Array<object> ) => {
      gGDPR_NonTCFVendors[index].consent = gGDPR_NonTCFVendors[index].modelConsent = false;
      });
    }
    
    __storeTCString();
}

// //
// // TCF Stub Implementation... iabtcf-es assumes this is available before initialization
// //


// (function () {
//   const makeStub = () => {
//     const TCF_LOCATOR_NAME = '__tcfapiLocator';
//     const queue = [];
//     const currentWindow = window;
//     let frameLocator = currentWindow;
//     let cmpFrame;
//     let gdprApplies;

//     function addFrame() {
//       const doc = currentWindow.document;
//       const otherCMP = !!(currentWindow.frames[TCF_LOCATOR_NAME]);

//       if (!otherCMP) {
//         if (doc.body) {
//           const iframe = doc.createElement('iframe');

//           iframe.style.cssText = 'display:none';
//           iframe.name = TCF_LOCATOR_NAME;
//           doc.body.appendChild(iframe);
//         } else {
//           setTimeout(addFrame, 5);
//         }
//       }

//       return !otherCMP;
//     }

//     function tcfAPIHandler(...args) {

//       // if ( args.length )
//       //   console.log( "stub tcfAPIHandler: " + args[0] );
//       // else
//       //   console.log( "stub tcfAPIHandler: no args" );

//       if (!args.length) {
//         /**
//          * shortcut to get the queue when the full CMP
//          * implementation loads; it can call tcfapiHandler()
//          * with no arguments to get the queued arguments
//          */

//         return queue;
//       } else if (args[0] === 'setGdprApplies') {
//         /**
//          * shortcut to set gdprApplies if the publisher
//          * knows that they apply GDPR rules to all
//          * traffic (see the section on "What does the
//          * gdprApplies value mean" for more
//          */
//         if (args.length > 3 && parseInt(args[1], 10) === 2 && typeof args[3] === 'boolean') {
//           gdprApplies = args[3];

//           if (typeof args[2] === 'function') {
//             args[2]('set', true);
//           }
//         }
//       } else if (args[0] === 'ping') {
//         /**
//          * Only supported method; give PingReturn
//          * object as response
//          */

//         console.log("ping in stub");

//         if (typeof args[2] === 'function') {
//           args[2]({
//             gdprApplies: gdprApplies,
//             cmpLoaded: false,
//             cmpStatus: 'stub',
//           });
//         }
//       } else {
//         /**
//          * some other method, just queue it for the
//          * full CMP implementation to deal with
//          */
//         queue.push(args);
//       }
//     }

//     function postMessageEventHandler(event) {
//       const msgIsString = typeof event.data === 'string';
//       let json = {};

//       if (msgIsString) {
//         try {
//           /**
//            * Try to parse the data from the event.  This is important
//            * to have in a try/catch because often messages may come
//            * through that are not JSON
//            */
//           json = JSON.parse(event.data);
//         } catch (ignore) {
//         }
//       } else {
//         json = event.data;
//       }

//       const payload = (typeof json === 'object' && json !== null) ? json.__tcfapiCall : null;

//       if (payload) {
//         window.__tcfapi(
//           payload.command,
//           payload.version,
//           function (retValue, success) {
//             let returnMsg = {
//               __tcfapiReturn: {
//                 returnValue: retValue,
//                 success: success,
//                 callId: payload.callId,
//               },
//             };
//             console.log( payload.command + " command relay in stub");


//             // console.log( "typeof returnMsg " + typeof returnMsg );
//             // console.log( "typeof returnMsg[ '__tcfapiReturn' ] " + typeof returnMsg[ '__tcfapiReturn' ] );
//             // console.log( "typeof returnMsg['__tcfapiReturn']['returnValue'] " + typeof returnMsg['__tcfapiReturn']['returnValue'] );
//             // console.log( "typeof returnMsg['__tcfapiReturn']['returnValue'] " + typeof returnMsg['__tcfapiReturn']['returnValue'] );

//             if ( payload.command != 'getVendorList' ) {
//               if (typeof returnMsg == 'object' && typeof returnMsg[ '__tcfapiReturn' ] == 'object' && typeof returnMsg['__tcfapiReturn']['returnValue'] == 'object' ) {
                
//                 // console.log( 'Checking gvlVersion in __tcfapi response');

//                 // console.log( typeof returnMsg['__tcfapiReturn']['returnValue']['gvlVersion']  )

//                 if ( typeof returnMsg['__tcfapiReturn']['returnValue']['gvlVersion'] == 'undefined' ) {
//                   // console.log( 'Setting GVL Version in __tcfapi response');

//                   if ( typeof window.__GVL == 'undefined' || typeof window.__GVL['vendorListVersion'] == 'undefined') {
//                     // console.log( '__GVL missing, force to loading');
//                     returnMsg['__tcfapiReturn'].returnValue.cmpLoaded = false;
//                     returnMsg['__tcfapiReturn'].returnValue.cmpStatus = 'loading';
//                     }
//                   else {
//                     // console.log( 'gvlVersion missing, set to ' + window.__GVL.vendorListVersion );
//                     returnMsg['__tcfapiReturn'].returnValue.gvlVersion = window.__GVL.vendorListVersion;
//                     }
    
//                   console.log( returnMsg['__tcfapiReturn'].returnValue );
//                 }
//               }
//             }

//             if (event && event.source && event.source.postMessage) {
//               event.source.postMessage((msgIsString) ? JSON.stringify(returnMsg) : returnMsg, '*');
//             }
//           },
//           payload.parameter,
//         );
//       }
//     }

//     /**
//      * Iterate up to the top window checking for an already-created
//      * "__tcfapilLocator" frame on every level. If one exists already then we are
//      * not the master CMP and will not queue commands.
//      */
//     while (frameLocator) {
//       try {
//         if (frameLocator.frames[TCF_LOCATOR_NAME]) {
//           cmpFrame = frameLocator;
//           break;
//         }
//       } catch (ignore) {
//       }

//       // if we're at the top and no cmpFrame
//       if (frameLocator === currentWindow.top) {
//         break;
//       }

//       // Move up
//       frameLocator = frameLocator.parent;
//     }

//     if (!cmpFrame) {
//       // we have recur'd up the windows and have found no __tcfapiLocator frame
//       addFrame();
//       currentWindow.__tcfapi = tcfAPIHandler;
//       currentWindow.addEventListener('message', postMessageEventHandler, false);
//     }
//   };

//   console.log( "Calling makeStub")

//   makeStub();

// }());



////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
//
// GPP Stub Implementation... iabgpp-es assumes this is available before
// initialization (code from https://github.com/IABTechLab/iabgpp-es/blob/master/modules/stub/src/stub.js)
//

window.__gpp_supportedAPIs = [
  "2:tcfeuv2",
// "5:tcfcav1",
// "6:uspv1",
// "7:usnatv1",
  "8:uscav1",
  "9:usvav1",
  "10:uscov1",
  "11:usutv1",
  "12:usctv1",
], // list of

window.__gpp_addFrame = function (n) {
  if (!window.frames[n]) {
    if (document.body) {
      var i = document.createElement("iframe");
      i.style.cssText = "display:none";
      i.name = n;
      document.body.appendChild(i);
    } else {
      window.setTimeout(window.__gpp_addFrame, 10, n);
    }
  }
};

window.__gpp_stub = function () {
  var b = arguments;
  __gpp.queue = __gpp.queue || [];
  __gpp.events = __gpp.events || [];

  if (!b.length || (b.length == 1 && b[0] == "queue")) {
    return __gpp.queue;
  }

  if (b.length == 1 && b[0] == "events") {
    return __gpp.events;
  }

  var cmd = b[0];
  var clb = b.length > 1 ? b[1] : null;
  var par = b.length > 2 ? b[2] : null;
  if (cmd === "ping") {
    clb(
      {
        gppVersion: "1.1", // must be “Version.Subversion”, current: “1.1”
        cmpStatus: "stub", // possible values: stub, loading, loaded, error
        cmpDisplayStatus: "hidden", // possible values: hidden, visible, disabled
        signalStatus: "not ready", // possible values: not ready, ready
        supportedAPIs: window.__gpp_supportedAPIs, // list of supported APIs
        cmpId: CMP_ID, // IAB assigned CMP ID, may be 0 during stub/loading
        sectionList: [],
        applicableSections: [],
        gppString: "",
        parsedSections: {},
      },
      true
    );
  } else if (cmd === "addEventListener") {
    if (!("lastId" in __gpp)) {
      __gpp.lastId = 0;
    }
    __gpp.lastId++;
    var lnr = __gpp.lastId;
    __gpp.events.push({
      id: lnr,
      callback: clb,
      parameter: par,
    });
    clb(
      {
        eventName: "listenerRegistered",
        listenerId: lnr, // Registered ID of the listener
        data: true, // positive signal
        pingData: {
          gppVersion: "1.1", // must be “Version.Subversion”, current: “1.1”
          cmpStatus: "stub", // possible values: stub, loading, loaded, error
          cmpDisplayStatus: "hidden", // possible values: hidden, visible, disabled
          signalStatus: "not ready", // possible values: not ready, ready
          supportedAPIs: window.__gpp_supportedAPIs, // list of supported APIs
          cmpId: CMP_ID, // IAB assigned CMP ID, may be 0 during stub/loading
          sectionList: [],
          applicableSections: [],
          gppString: "",
          parsedSections: {},
        },
      },
      true
    );
  } else if (cmd === "removeEventListener") {
    var success = false;
    for (var i = 0; i < __gpp.events.length; i++) {
      if (__gpp.events[i].id == par) {
        __gpp.events.splice(i, 1);
        success = true;
        break;
      }
    }
    clb(
      {
        eventName: "listenerRemoved",
        listenerId: par, // Registered ID of the listener
        data: success, // status info
        pingData: {
          gppVersion: "1.1", // must be “Version.Subversion”, current: “1.1”
          cmpStatus: "stub", // possible values: stub, loading, loaded, error
          cmpDisplayStatus: "hidden", // possible values: hidden, visible, disabled
          signalStatus: "not ready", // possible values: not ready, ready
          supportedAPIs: window.__gpp_supportedAPIs, // list of supported APIs
          cmpId: CMP_ID, // IAB assigned CMP ID, may be 0 during stub/loading
          sectionList: [],
          applicableSections: [],
          gppString: "",
          parsedSections: {},
        },
      },
      true
    );
  } else if (cmd === "hasSection") {
    clb(false, true);
  } else if (cmd === "getSection" || cmd === "getField") {
    clb(null, true);
  }
  //queue all other commands
  else {
    __gpp.queue.push([].slice.apply(b));
  }
};
window.__gpp_msghandler = function (event) {
  var msgIsString = typeof event.data === "string";
  try {
    var json = msgIsString ? JSON.parse(event.data) : event.data;
  } catch (e) {
    var json = null;
  }
  if (typeof json === "object" && json !== null && "__gppCall" in json) {
    var i = json.__gppCall;

    console.log( " ||||||||||||||||||||||| GPP Call: " + i.command );
    window.__gpp(
      i.command,
      function (retValue, success) {
        var returnMsg = {
          __gppReturn: {
            returnValue: retValue,
            success: success,
            callId: i.callId,
          },
        };
        event.source.postMessage(msgIsString ? JSON.stringify(returnMsg) : returnMsg, "*");
      },
      "parameter" in i ? i.parameter : null,
      "version" in i ? i.version : "1.1"
    );
  }
};
if (!("__gpp" in window) || typeof window.__gpp !== "function") {
  window.__gpp = window.__gpp_stub;
  window.addEventListener("message", window.__gpp_msghandler, false);
  window.__gpp_addFrame("__gppLocator");
}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////

var __gppEventListenerReturn = __gpp('addEventListener', ( event ) => { 
  
  // console.log( "GPP EVENT" )
  // console.log( event )
  if (event.eventName == "sectionChanged")  {
    ampLogInfo( "GPP sectionChanged " )
    __updateGPPCookie();

    // __gpp("getSection", function (data, success) {
    //   console.log("Here's the tcfeuv2 section...");
    //   console.log(data, success);
    // }, 'tcfeuv2');
    
  }
});


////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
//
//  Startup
//


function __dumptcfping( label ) {
  // console.log( "#x checking for __uspapi() function > " + typeof __uspapi + " (" + label + ")" );
  
  // try {
  // __uspapi = undefined;
  // } catch (e) {
  // }
//   __tcfapi( 'ping', 2, (data, success) => {

//     let objectASString = JSON.stringify(data, null, 2);
//     console.log( 'TCF Ping ' + label + " : " + objectASString );
//     console.log( data );
//     console.log( window.__cmpTCModel );
//     console.log( window.__GVL );
//  } 
//  );

}

// const __tcfeventlistenercallback = (tcData, success) => {
//   let objectASString = JSON.stringify(tcData, null, 2);
//   console.log( "__tcfeventlistenercallback : " + objectASString );
// }

// __tcfapi('addEventListener', 2, __tcfeventlistenercallback );



// @ts-ignore
declare var gGDPR_NonTCFVendors: object[];  // external variable in site layout file...

let cmpApi = undefined; // new CmpApi(CMP_ID, CMP_BUILD); 
let tcfCmpApi = undefined; // new TCFCmpApi( CMP_ID, CMP_VERSION, false );

__dumptcfping( "main" );


function startupCMP() {

  __dumptcfping( "startupCMP()" );



  GVL.baseUrl = "https://qd.admetricspro.com/js/gpp/vendor-list-v3/";
  GVL.latestFilename = 'vendor-list.json';   

  window.__GVL = new GVL();    // event handler from this load kicks everything off
  

  if ( typeof gGDPR_NonTCFVendors == 'undefined' ) {
    gGDPR_NonTCFVendors = [];
  }

  let clearConsent = getParameterByName("ampGPPClear");

  if ( clearConsent ) {
    ampLogInfo( "ampGPPClear present, clearing consent and geolocation" );
    setCookie(  "amp_pieog", "", 7);
    setCookie( CMP_CONSENTCOOKIE, "", 7);
    setCookie(  CMP_GPP_CONSENTCOOKIE, "", 7);

  }

  // console.log(" >>>>>>>> Before CmpApi <<<<<<<<<<<<<<<<<<<");

  var gppResponseFunc = function( tcData, success ) {
    if ( typeof success != "undefined" && success == false ) {      // gpp 1.0 does not have success in callback
        console.log( "CMP error response" )
    } else {
      console.log( tcData );
    }
    }


  // console.log( __gpp( 'ping', gppResponseFunc ) );
  // console.log(" >>>>>>>> SETTING CmpApi <<<<<<<<<<<<<<<<<<<");



  // console.log(" >>>>>>>> After CmpApi <<<<<<<<<<<<<<<<<<<");
  // console.log( __gpp( 'ping', gppResponseFunc ) );
  // console.log(" >>>>>>>>  >>>>><<<<<   <<<<<<<<<<<<<<<<<");

  // window.__gpp = cmpApi;


  function copyModelBlobToModel( modelBlob ) {

    // console.log( "Creating new TCModel from existing blob");
    __dumptcfping( "copyModelBlobToModel(): begin" );

    // Some TCString methods that are supposed to return TCModel objects don't;
    // what comes back seems to be something like data blob with TCModel's fields
    // but isn't actually a TCModel object. 

    // So right here we've got something that resembles a TCModel in modelBlob,
    // but if we just blindly assign it to window.__cmpTCModel it totally fucks it
    // up in way that causes future calls to encode the consent string to fail
    // with errors deep in the IAB libraries. So what we're going to do here is
    // copy the relevent consent options from modelBlob into __cmpTCModel so
    // that __cmpTCModel is still an actual object with callable methods.

    // This code is super brittle and if the definition of TCModel changes
    // for something like TCF 2.3 or some other future version, we'll need
    // to update the fields here.

    //@ts-ignore
    window.__cmpTCModel.unsetAll();

    //@ts-ignore
    window.__cmpTCModel.lastUpdated = modelBlob.lastUpdated;
    //@ts-ignore
    window.__cmpTCModel.created = modelBlob.created;
    //@ts-ignore
    window.__cmpTCModel.policyVersion = modelBlob.policyVersion;
    //@ts-ignore
    window.__cmpTCModel.policyVersion = modelBlob.policyVersion;
    //@ts-ignore
    window.__cmpTCModel.consentScreen = modelBlob.consentScreen;
    //@ts-ignore
    window.__cmpTCModel.isServiceSpecific = modelBlob.isServiceSpecific;
    //@ts-ignore
    window.__cmpTCModel.policyVersion = modelBlob.policyVersion;
    //@ts-ignore
    window.__cmpTCModel.publisherCountryCode = modelBlob.publisherCountryCode; 
    //@ts-ignore
    window.__cmpTCModel.vendorLegitimateInterests = modelBlob.vendorLegitimateInterests;
    //@ts-ignore
    window.__cmpTCModel.supportOOB = modelBlob.supportOOB;
    //@ts-ignore
    window.__cmpTCModel.useNonStandardStacks = modelBlob.useNonStandardStacks;
    //@ts-ignore
    window.__cmpTCModel.vendorListVersion = modelBlob.vendorListVersion;
    //@ts-ignore
    window.__cmpTCModel.version = modelBlob.version;

    window.__cmpTCModel.publisherConsents = modelBlob.publisherConsents;
    window.__cmpTCModel.publisherCustomConsents = modelBlob.publisherCustomConsents;
    window.__cmpTCModel.publisherCustomLegitimateInterests = modelBlob.publisherCustomLegitimateInterests;
    window.__cmpTCModel.publisherLegitimateInterests = modelBlob.publisherLegitimateInterests;

    window.__cmpTCModel.purposeConsents = modelBlob.purposeConsents;
    window.__cmpTCModel.purposeLegitimateInterests = modelBlob.purposeLegitimateInterests;
    window.__cmpTCModel.specialFeatureOptins = modelBlob.specialFeatureOptins;
    window.__cmpTCModel.vendorConsents = modelBlob.vendorConsents;
    if( window.__cmpTCModel.vendorsDisclosed) 
      window.__cmpTCModel.vendorsDisclosed = modelBlob.vendorsDisclosed;
    __dumptcfping( "copyModelBlobToModel(): end" );

  }


  let geoIPCallback = function( status: boolean, country : string, region : string ) {
      if ( ! status ) {
        ampLogError( "Error getting visitor country and region");
        return;
      } 

      __dumptcfping( "__tcfapi start of geo callback" );

      cmpApi = new CmpApi(CMP_ID, CMP_BUILD); 
      // tcfCmpApi = new TCFCmpApi( CMP_ID, CMP_VERSION, false );
      
      // tcfCmpApi.tcModel = window.__cmpTCModel;
      // tcfCmpApi.tcModel.cmpId = CMP_ID;
      // tcfCmpApi.tcModel.cmpVersion = CMP_VERSION;

      cmpApi.setSupportedAPIs( window.__gpp_supportedAPIs );


      let tcfConsentString = getCookie( CMP_CONSENTCOOKIE );

      let consentString = __getGPPCookie( );

      if (consentString ) {
        ampLogInfo( "Initializing with existing GPP consent string: " + consentString);
        cmpApi.setGppString(consentString);
      }
      else {
        ampLogInfo( "No exisiting consent found, clearing GPP consent string");
        cmpApi.clear();
      }

      cmpApi.setCmpStatus( "loaded" );

      let forcedCountryCode = getParameterByName("ampGPPCMPCC");
      let forcedRegionCode = getParameterByName("ampGPPCMPRegion");

      if ( forcedCountryCode )
        country = forcedCountryCode
      
      if ( forcedRegionCode )
        region = forcedRegionCode
        
     ampLogInfo( "Visitor country: " + country + " region: " + region );

      const gdprApplies = isGDPRCountry( country  );
      const isUSA = country == "US";

      ampLogInfo( "GDPR " + ( gdprApplies ? "applies." : "does not apply." ) );

      nextTick( () => {
        // console.log( "__cmpOpenUI():  nextTick" );

        let initalLayer = "";
        let openCMP = false;

        if (gdprApplies) {
          initalLayer = "layerOne";
          cmpApi.setApplicableSections( [ TcfEuV2.ID ] );

          if ( cmpApi.hasSection( 'tcfeuv2') ) {
            ampLogInfo( "GDPR TCF EU V2.x Privacy Data Present, initializing without opening CMP UI");
            cmpApi.setSignalStatus( "ready" );
            cmpApi.fireEvent( 'signalStatus', 'ready' );
            openCMP = false;

            // get the current GVL version

            let gvlVersion = window.__GVL.vendorListVersion;


            // console.log( "Decoding tcf consent string into model...");
            let tcModelBlob = TCString.decode(tcfConsentString, window.__GVL );
            copyModelBlobToModel( tcModelBlob );
            // __dumptcfping( "geoIPCallback: BEFORE DECODE @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@" );

            // window.__cmpTCModel = TCString.decode(tcfConsentString, window.__GVL );

            __dumptcfping( "geoIPCallback: AFTER DECODE" );

            // get the GVL version out of the tcModelBlob
            
            let existingConsentVendorVersion = tcModelBlob.vendorListVersion;

            if ( existingConsentVendorVersion != gvlVersion ) {
              ampLogInfo( "Found old GVL Version in existing consent, forcing CMP UI to open");
              openCMP = true;
            }

            // tcfCmpApi.update(tcfConsentString, false); // not showing the ui to the user

            __dumptcfping( " geo callback gdprApplies, tcfeuv2 present" );

          } else {
            __dumptcfping( " geo callback gdprApplies, missing tcfeuv2 (before update)" );

            if (tcfConsentString != "") {
              // console.log( "Decoding tcf consent string into model (2)...");

              let tcModelBlob = TCString.decode(tcfConsentString, window.__GVL );
              copyModelBlobToModel( tcModelBlob );

            }
            // tcfCmpApi.update(tcfConsentString, true); // showing the ui to the user

            __dumptcfping( " geo callback gdprApplies, missing tcfeuv2 (after update)" );

            openCMP = true;
          }       


        } else {
          function test( regiontoTest, stateName, cmpSection, cmpSectionID, cmpDisplayLayer, grantConsentFunc ) {
            if ( isUSA && (region == regiontoTest) ) {
              initalLayer = cmpDisplayLayer;

              cmpApi.setApplicableSections( [ cmpSectionID ] );

              if ( cmpApi.hasSection( cmpSection ) ) {
                ampLogInfo( stateName + " Privacy Data Present, initializing from stored consent");
                cmpApi.setSignalStatus( "ready" );
                cmpApi.fireEvent( 'signalStatus', 'ready' );
                openCMP = false;
              } else {
                ampLogInfo( stateName + " Privacy Data Not Present, initializing with default consent");
                grantConsentFunc( true, cmpApi, true );
                cmpApi.setSignalStatus( "ready" );
                cmpApi.fireEvent( 'signalStatus', 'ready' );
                openCMP = false;
              }       
            }
          }
  
          test( "CA", "California", UsCaV1.NAME, UsCaV1.ID, "layerStateCalifornia", updateCMPCalifornia );
          test( "CO", "Colorado", UsCoV1.NAME, UsCoV1.ID, "layerStateColorado", updateCMPColorado );
          test( "CT", "Connecticut", UsCtV1.NAME, UsCtV1.ID, "layerStateConnecticut", updateCMPConnecticut );
          test( "UT", "Utah", UsUtV1.NAME, UsUtV1.ID, "layerStateUtah", updateCMPUtah );
          test( "VA", "Virginia", UsVaV1.NAME, UsVaV1.ID, "layerStateVirginia", updateCMPVirginia );
  
          }

          // console.log( ">>>>> CMP(): initalLayer = " + initalLayer + " openCMP = " + openCMP );

        if ( initalLayer ) {
          let props =  {
            initialVisible: true,
            reopenLayer:initalLayer,
            initialLayer:openCMP ? initalLayer : "close",
            cmpApi: cmpApi,
            storeTCString: __storeTCString,
            storeAcceptAllTCString: __storeAcceptAllTCString,
            storeRejectAllTCString: __storeRejectAllTCString,
          }
          __dumptcfping( " creating app" );

          __gppAppInstance = createApp( App, props ).mount('#' + __gppMountDivID);


          // @ts-ignore
          // tcfCmpApi.update("", true);   // on initial open, assume no existing string, otherwise we wouldn't be here...


        } else {
          cmpApi.setSignalStatus( "ready" );
          cmpApi.fireEvent( 'signalStatus', 'ready' );
        }
      } );
    }

    window.__GVL.readyPromise.then( () => { 
      // @ts-ignore
      ampLogInfo( "GVL version is " + window.__GVL.vendorListVersion)
      // console.log( "#2 checking for __uspapi() function > " + typeof __uspapi );


      window.__cmpTCModel = new TCModel( window.__GVL );  
      window.__cmpTCModel.cmpId = CMP_ID;
      window.__cmpTCModel.cmpVersion = CMP_VERSION;
      window.__cmpTCModel.consentScreen = 1;
      window.__cmpTCModel.isServiceSpecific = true;
      window.__cmpTCModel.publisherCountryCode = typeof gGDPR_publisherCountryCode != 'undefined' ? gGDPR_publisherCountryCode : 'US';
    
      
      __dumptcfping( " gvl ready" );

      // @ts-ignore
      // const encodedString = TCString.encode(window.__cmpTCModel);
      // ampLogInfo( encodedString);

      getVisitorCountryAndRegion( geoIPCallback );

  } ); 
}




ampLogInfo( "AdMetricsPro GPP CMP v" + CMP_BUILD) 


  // console.log( "#1 checking for __uspapi() function > " + typeof __uspapi );

function doStartup() {
  ampLogInfo( "AdMetricsPro GPP CMP Startup...");
  __injectDOMElements( );
  startupCMP();
}

// if document state is complete, start the CMP, otherwise wait for it to be ready

if (document.readyState === 'complete') {
  doStartup();
} else {
  window.addEventListener('load', doStartup);
}




    // cmpApi.setGppString(gppString);


//     if ( ! cookie ) {
//       console.log( "CMP: GDPR applies and no existing consent")
//       targetLayer = "layerOne";
//     } else if ( needNewConsent ) {
//       console.log( "CMP: consent out dated, requesting new consent")
//       targetLayer = "layerOne";
//     }
//     else     
//       console.log( "CMP: GDPR applies, using existing consent")
//   }
//   else
//   {
//     console.log( "CMP: GDPR does not apply ")
//     cmpApi.update(null);
//   }

